import PinIcon from './component'

export default PinIcon
